import { attr, Model, ModelType } from 'redux-orm';
import {
  GET_VIEWS_SUCCESS,
  UPDATE_VIEW_SUCCESS,
  NEW_VIEW_SUCCESS,
} from 'actions';
import { ViewType, ViewTimeframeFilter, ViewSourceFilter } from 'enums';
import { ColumnState } from '@ag-grid-community/core';

export interface IView {
  /**
   * The unique identifier
   */
  id: string;
  /**
   * The label of the filter
   */
  label?: string;
  /**
   * The sort model to be applied to the AgGrid
   * columnState now handles this.  TODO. Remove.
   */
  sortModel?: Array<{ colId: string; sort: string }>;
  /**
   * The filter model to be applied to the AgGrid
   */
  filterModel?: Record<string, unknown>;
  /**
   * The column state to be applied to the AgGrid
   */
  columnState?: ColumnState[];
  /**
   * Flag indicating if the filter is public (shared)
   */
  isPublic?: boolean;
  /**
   * Flag indicating if the filter is archived
   */
  isArchived?: boolean;
  /**
   * Flag indicating if the filter is a system filter and cannot be changed
   */
  isSystem?: boolean;
  /**
   * The type of entity the view is associated with
   */
  entityType: ViewType;
  /**
   * The userId of the filter creator
   */
  ownerId: string;
  /**
   * The source applied to the datagrid
   */
  source: ViewSourceFilter[];
  /**
   * The timeframe applied to the datagrid
   */
  timeframe: ViewTimeframeFilter;
}

interface Action {
  type: string;
  views?: IView[];
  view?: IView;
}

class View extends Model<typeof View, IView> {
  static reducer(action: Action, model: ModelType<View>) {
    // eslint-disable-next-line default-case
    switch (action.type) {
      case GET_VIEWS_SUCCESS:
        action.views?.forEach((view) => {
          model.upsert(view);
        });
        break;
      case UPDATE_VIEW_SUCCESS:
      case NEW_VIEW_SUCCESS:
        if (action.view) {
          model.upsert(action.view);
        }
        break;
    }
  }

  toViewModel() {
    return {
      ...this.ref,
    };
  }
}

View.modelName = 'View';

View.fields = {
  id: attr(),
  ownerId: attr(),
  label: attr(),
  interactionSource: attr(),
  timeframe: attr(),
  filterModel: attr(),
  sourceModal: attr(),
  columnState: attr(),
  visibility: attr(),
};

export type ViewViewModel = ReturnType<View['toViewModel']>;

export default View;
